(function ($, Drupal) {
  Drupal.behaviors.destacado = {
    attach: function attach(context, settings) {
      if (!context.querySelector) return;
      var swiperElement = context.querySelector('.destacados-swiper');
      if (!swiperElement || swiperElement.swiper) return;
      
      new Swiper(".destacados-swiper", {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: true,
        touchEventsTarget: 'container',
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          768: {
            slidesPerView: 1
          },
          1024: {
            slidesPerView: 1
          }
        }
      });
    }
  };
})(jQuery, Drupal);